module.exports = __webpack_public_path__ + "static/widernet-packaging-62eed23ec162941e4c7b4a7e5b5f3aa1.jpg";